import { Injectable, Type } from '@angular/core';
import { UnsupportedTableCellComponent } from '../shared/unsupported/table-cell/unsupported-table-cell.component';
import { TextFormFieldComponent } from '../shared/text/form-field/text-form-field.component';
import { NumberFormFieldComponent } from '../shared/number/form-field/number-form-field.component';

import { UnsupportedFormFieldComponent } from '../shared/unsupported/form-field/unsupported-form-field.component';
import { CheckboxFormFieldComponent } from '../shared/checkbox/form-field/checkbox-form-field.component';
import { OptionFormFieldComponent } from '../shared/option/form-field/option-form-field.component';
import { DateFormFieldComponent } from '../shared/date/form-field/date-form-field.component';
import { SymbolTableCellComponent } from '../shared/symbol/table-cell/symbol-table-cell.component';
import { SymbolFormFieldComponent } from '../shared/symbol/form-field/symbol-form-field.component';
import { RateFormFieldComponent } from '../shared/rate/form-field/rate-form-field.component';
import { RateTableCellComponent } from '../shared/rate/table-cell/rate-table-cell.component';
import { HtmlFormFieldComponent } from '../shared/html/form-field/html-form-field.component';
import { ColorFormFieldComponent } from '../shared/color/form-field/color-form-field.component';
import { MultiOptionFormFieldComponent } from '../shared/multi-option/form-field/multi-option-form-field.component';
import { EmojiFormFieldComponent } from '../shared/emoji/form-field/emoji-form-field.component';
import { EmojiTableCellComponent } from '../shared/emoji/table-cell/emoji-table-cell.component';
import { MoneyFormFieldComponent } from '../shared/money/form-field/money-form-field.component';
import { LookupFormFieldComponent } from '../shared/lookup/single-lookup/lookup-from-field/lookup-form-field.component';
import { LookupPagedFormFieldComponent } from '../shared/lookup/lookup-paged/lookup-paged-form-field/lookup-paged-form-field.component';
import { SpendingLimitComponent } from '../shared/spending-limit/form-field/spending-limit.component';
import { PrizeTableFormFieldComponent } from '../draws/prize-table/form-field/prize-table-form-field.component';
import { DrawOptionsFormFieldComponent } from '../draws/draw-options/form-field/draw-options-form-field.component';
import { BoosterFormFieldComponent } from '../draws/booster/form-field/booster-form-field.component';
import { QuickPicksFormFieldComponent } from '../draws/quick-picks/form-field/quick-picks-form-field.component';
import { DateTimeFormFieldComponent } from '../shared/date-time/form-field/date-time-form-field.component';
import { FutureDrawsFormFieldComponent } from '../draws/future_draws/form-field/future-draws-form-field.component';

import * as Lottomart from '../lottomart/lottomart.index';
import { LottoLineFormFieldComponent, LottoLineTableCellComponent } from '../lottomart/lottomart.index';
import * as Backoffice from '../backoffice/backoffice.index';

import { OddsFormFieldComponent } from '../shared/odds/form-field/odds-form-field.component';
import { NewMoneyFormFieldComponent } from '../shared/new-money/form-field/new-money-form-field.component';

import { AvatarFormFieldComponent } from '../shared/avatar/form-field/avatar-form-field.component';
import { AvatarTableCellComponent } from '../shared/avatar/table-cell/avatar-table-cell.component';

import { ImageTableCellComponent } from '../shared/image/table-cell/image-table-cell.component';
import { ImageFormFieldComponent } from '../shared/image/form-field/image-form-field.component';

import { NestedTableFormFieldComponent } from '../shared/nested-table/form-field/nested-table-form-field.component';

import { ToggleFormFieldComponent } from '../shared/toggle/form-field/toggle-form-field.component';
import { ToggleTableCellComponent } from '../shared/toggle/table-cell/toggle-table-cell.component';

import { ReportFormFieldComponent } from '../shared/report/form-field/report-form-field.component';
import { PropertiesFormFieldComponent } from '../shared/properties/form-field/properties-form-field.component';
import { LogoFormFieldComponent } from '../shared/logo/form-field/logo-form-field.component';

import { ShapeFormFieldComponent } from '../shared/shape/form-field/shape-form-field.component';
import { ShapeTableCellComponent } from '../shared/shape/table-cell/shape-table-cell.component';

import { HtmlBlockFormFieldComponent } from '../shared/html-block/form-field/html-block-form-field.component';

import { NestedPanelFormFieldComponent } from '../shared/nested-panel/form-field/nested-panel-form-field.component';
import { LinkFormFieldComponent } from '../shared/link/form-field/link-form-field.component';

import { ImageUploaderTableCellComponent } from '../shared/image-uploader/table-cell/image-uploader-table-cell.component';
import { ImageUploaderFormFieldComponent } from '../shared/image-uploader/form-field/image-uploader-form-field.component';
import { DiamondPanelFormFieldComponent } from '../lottomart/diamond-panel/form-field/diamond-panel-form-field.component';

import { CardPanelFormFieldComponent } from '../lottomart/card-panel/form-field/card-panel-form-field.component';
import { CardPanelTableCellComponent } from '../lottomart/card-panel/table-cell/card-panel-table-cell.component';

import { HeroSlideFormFieldComponent } from '../lottomart/hero-slide/form-field/hero-slide-form-field.component';
import { HeroSlidesFormFieldComponent } from '../lottomart/hero-slides/form-field/hero-slides-form-field.component';
import { CodeFormFieldComponent } from '../shared/code/form-field/code-form-field.component';
import { DateRangeFormFieldComponent } from '../shared/date-range/form-field/date-range-form-field.component';
import { DataType } from '../data-type-component';
import { GraphFormFieldComponent } from '../shared/graph/form-field/graph-form-field.component';
import { FileUploadFormFieldComponent } from '../shared/file-upload/form-field/file-upload-form-field.component';
import { TimeFormFieldComponent } from '../shared/time/form-field/time-form-field.component';
import { ChartFormFieldComponent } from '../shared/chart/form-field/chart-form-field.component';
import { DeeplinkFormFieldComponent } from '../lottomart/deeplink/form-field/deeplink-form-field.component';
import { DeeplinkTableCellComponent } from '../lottomart/deeplink/table-cell/deeplink-table-cell.component';
import { BundleFormFieldComponent } from '../lottomart/bundle/form-field/bundle-form-field.component';
import { OpenInPlayerFormFieldComponent } from '../lottomart/open-in-player/form-field/open-in-player-form-field.component';
import { IframeFormFieldComponent } from '../shared/iframe/form-field/iframe-form-field.component';
import { VideoFormFieldComponent } from '../shared/video/form-field/video-form-field.component';
import { MapFormFieldComponent } from '../shared/map/form-field/map-form-field.component';
import { MetricFormFieldComponent } from '../shared/metric/form-field/metric-form-field.component';
import { TreeFormFieldComponent } from '../shared/tree/form-field/tree-form-field.component';
import { MultiLookupFormFieldComponent } from '../shared/lookup/multi-lookup/multi-lookup-form-field/multi-lookup-form-field.component';
import { RuleFormFieldComponent } from '../lottomart/rule/form-field/rule-form-field.component';
import { CodePenFormFieldComponent } from '../shared/codepen/form-field/code-pen-form-field.component';
import { SiteTreeFormFieldComponent } from '../shared/site-tree/form-field/site-tree-form-field.component';
import { DynamicLinkFormFieldComponent } from '../shared/dynamic-link/form-field/dynamic-link-form-field.component';
import { PlayerInfoFormFieldComponent } from '../shared/player-info/form-field/player-info-form-field.component';
import { SmartFilterFormField } from '../lottomart/smart-filters/form-field/smart-filter-form-field.component';
import { DurationFormFieldComponent } from '../shared/duration/form-field/duration-form-field.component';
import { OptionPanelFormFieldComponent } from '../shared/option-panel/form-field/option-panel-form-field.component';
import { OptionPanelTableCellComponent } from '../shared/option-panel/table-cell/option-panel-table-cell.component';
import { StarFormFieldComponent } from '../shared/star/form-field/star-form-field.component';
import { EntityRestrictionCheckboxFormFieldComponent } from '../shared/entity-restriction-checkbox/form-field/entity-restriction-checkbox-form-field.component';
import { AvailabilitySummaryFormFieldComponent } from '../shared/availability-summary/form-field/availability-summary-form-field.component';
import { StopwatchFormFieldComponent } from '../shared/stopwatch/form-field/stopwatch-form-field.component';
import { DepositsIn24hThresholdOverrideComponent } from '../player/deposits-in-24h-threshold-override/deposits-in-24h-threshold-override.component';
import { PersonalMonthlyNetLossThresholdComponent } from '../player/personal-monthly-net-loss-threshold/personal-monthly-net-loss-threshold.component';
import { AffordabilitySettingsComponent } from '../backoffice/affordability-settings/affordability-settings.component';
import { LifetimeNetLossThresholdsComponent } from '../backoffice/lifetime-net-loss-thresholds/lifetime-net-loss-thresholds.component';
import { NetLossesComponent } from '../backoffice/net-losses/net-losses.component';
import { PromotionExcludeComponent } from '../player/promotion-exclude/promotion-exclude.component';
import { LifetimeDepositThresholdsComponent } from '../backoffice/lifetime-deposit-thresholds/lifetime-deposit-thresholds.component';
import { PersonalLifetimeThresholdsComponent } from '../player/personal-lifetime-thresholds/personal-lifetime-thresholds.component';
import { PlayerConsentsComponent } from '../player/player-consents/player-consents.component';
import { PromoClaimRateComponent } from '../player/promo-claim-rate/promo-claim-rate.component';
import { PlayerAppliedRestrictionsTabComponent } from '../../../../feature/manage/player/player-details/components/player-header-bar/player-status-widget/player-applied-restrictions-tab/player-applied-restrictions-tab.component';
import { ResponsibleGamingConfigCardComponent } from '../../../../feature/manage/player/player-details/components/responsible-gaming/responsible-gaming-config-card/responsible-gaming-config-card.component';

@Injectable()
export class DataTypeService {
  constructor() {}

  private dataTypes: Map<DataType, DataTypeWidgetWrapper> = new Map<DataType, DataTypeWidgetWrapper>([
    [
      DataType.text,
      {
        formFieldComponent: TextFormFieldComponent,
        tableCellComponent: TextFormFieldComponent,
      },
    ],
    [DataType.textarea, { formFieldComponent: TextFormFieldComponent, tableCellComponent: TextFormFieldComponent }],
    [
      DataType.number,
      {
        formFieldComponent: NumberFormFieldComponent,
        tableCellComponent: NumberFormFieldComponent,
      },
    ],
    [
      DataType.checkbox,
      {
        formFieldComponent: CheckboxFormFieldComponent,
        tableCellComponent: CheckboxFormFieldComponent,
      },
    ],
    [
      DataType.entity_restriction_checkbox,
      {
        formFieldComponent: EntityRestrictionCheckboxFormFieldComponent,
        tableCellComponent: EntityRestrictionCheckboxFormFieldComponent,
      },
    ],
    [DataType.option, { formFieldComponent: OptionFormFieldComponent, tableCellComponent: OptionFormFieldComponent }],
    [
      DataType.date,
      {
        formFieldComponent: DateFormFieldComponent,
        tableCellComponent: DateFormFieldComponent,
      },
    ],
    [
      DataType.date_time,
      {
        formFieldComponent: DateTimeFormFieldComponent,
        tableCellComponent: DateTimeFormFieldComponent,
      },
    ],
    [DataType.time, { formFieldComponent: TimeFormFieldComponent, tableCellComponent: TimeFormFieldComponent }],
    [
      DataType.date_range,
      {
        formFieldComponent: DateRangeFormFieldComponent,
        tableCellComponent: DateRangeFormFieldComponent,
      },
    ],
    [DataType.symbol, { formFieldComponent: SymbolFormFieldComponent, tableCellComponent: SymbolTableCellComponent }],
    [DataType.rate, { formFieldComponent: RateFormFieldComponent, tableCellComponent: RateTableCellComponent }],
    [DataType.html, { formFieldComponent: HtmlFormFieldComponent, tableCellComponent: null }],
    [DataType.color, { formFieldComponent: ColorFormFieldComponent, tableCellComponent: null }],
    [
      DataType.multi_option,
      { formFieldComponent: MultiOptionFormFieldComponent, tableCellComponent: MultiOptionFormFieldComponent },
    ],
    [DataType.emoji, { formFieldComponent: EmojiFormFieldComponent, tableCellComponent: EmojiTableCellComponent }],
    [
      DataType.money,
      {
        formFieldComponent: MoneyFormFieldComponent,
        tableCellComponent: MoneyFormFieldComponent,
      },
    ],
    [DataType.lookup, { formFieldComponent: LookupFormFieldComponent, tableCellComponent: LookupFormFieldComponent }],
    [
      DataType.paged_lookup,
      { formFieldComponent: LookupPagedFormFieldComponent, tableCellComponent: LookupPagedFormFieldComponent },
    ],
    [
      DataType.multi_lookup,
      {
        formFieldComponent: MultiLookupFormFieldComponent,
        tableCellComponent: MultiLookupFormFieldComponent,
      },
    ],
    [
      DataType.condition,
      {
        formFieldComponent: Lottomart.ConditionFormFieldComponent,
        tableCellComponent: Lottomart.ConditionTableCellComponent,
      },
    ],
    [
      DataType.offer,
      {
        formFieldComponent: Lottomart.OfferFormFieldComponent,
        tableCellComponent: Lottomart.OfferTableCellComponent,
      },
    ],
    [
      DataType.option_panel,
      {
        formFieldComponent: OptionPanelFormFieldComponent,
        tableCellComponent: OptionPanelTableCellComponent,
      },
    ],
    [DataType.spending_limit, { formFieldComponent: SpendingLimitComponent, tableCellComponent: null }],
    [DataType.prize_table, { formFieldComponent: PrizeTableFormFieldComponent, tableCellComponent: null }],
    [DataType.draw_options, { formFieldComponent: DrawOptionsFormFieldComponent, tableCellComponent: null }],
    [DataType.booster, { formFieldComponent: BoosterFormFieldComponent, tableCellComponent: null }],
    [DataType.quick_picks, { formFieldComponent: QuickPicksFormFieldComponent, tableCellComponent: null }],
    [DataType.avatar, { formFieldComponent: AvatarFormFieldComponent, tableCellComponent: AvatarTableCellComponent }],
    [DataType.image, { formFieldComponent: ImageFormFieldComponent, tableCellComponent: ImageTableCellComponent }],
    [
      DataType.image_uploader,
      {
        formFieldComponent: ImageUploaderFormFieldComponent,
        tableCellComponent: ImageUploaderTableCellComponent,
      },
    ],
    [
      DataType.lotto_line,
      {
        formFieldComponent: LottoLineFormFieldComponent,
        tableCellComponent: LottoLineTableCellComponent,
      },
    ],
    [DataType.toggle, { formFieldComponent: ToggleFormFieldComponent, tableCellComponent: ToggleTableCellComponent }],
    [DataType.report, { formFieldComponent: ReportFormFieldComponent, tableCellComponent: null }],
    [DataType.future_draws, { formFieldComponent: FutureDrawsFormFieldComponent, tableCellComponent: null }],
    [DataType.properties, { formFieldComponent: PropertiesFormFieldComponent, tableCellComponent: null }],
    [DataType.logo, { formFieldComponent: LogoFormFieldComponent, tableCellComponent: LogoFormFieldComponent }],
    [
      DataType.nested_table,
      {
        formFieldComponent: NestedTableFormFieldComponent,
        tableCellComponent: NestedTableFormFieldComponent,
      },
    ],
    [
      DataType.sub_panel,
      {
        formFieldComponent: NestedPanelFormFieldComponent,
        tableCellComponent: NestedPanelFormFieldComponent,
      },
    ],
    [
      DataType.diamond_panel,
      {
        formFieldComponent: DiamondPanelFormFieldComponent,
        tableCellComponent: DiamondPanelFormFieldComponent,
      },
    ],
    [
      DataType.card_panel,
      {
        formFieldComponent: CardPanelFormFieldComponent,
        tableCellComponent: CardPanelTableCellComponent,
      },
    ],
    [
      DataType.hero_slide,
      {
        formFieldComponent: HeroSlideFormFieldComponent,
        tableCellComponent: HeroSlideFormFieldComponent,
      },
    ],
    [DataType.hero_slides, { formFieldComponent: HeroSlidesFormFieldComponent, tableCellComponent: null }],
    [DataType.link, { formFieldComponent: LinkFormFieldComponent, tableCellComponent: LinkFormFieldComponent }],
    [DataType.code, { formFieldComponent: CodeFormFieldComponent, tableCellComponent: null }],
    [DataType.graph, { formFieldComponent: GraphFormFieldComponent, tableCellComponent: null }],
    [DataType.shape, { formFieldComponent: ShapeFormFieldComponent, tableCellComponent: ShapeTableCellComponent }],
    [
      DataType.file_upload,
      {
        formFieldComponent: FileUploadFormFieldComponent,
        tableCellComponent: FileUploadFormFieldComponent,
      },
    ],
    [DataType.chart, { formFieldComponent: ChartFormFieldComponent, tableCellComponent: null }],
    [
      DataType.deeplink,
      {
        formFieldComponent: DeeplinkFormFieldComponent,
        tableCellComponent: DeeplinkTableCellComponent,
      },
    ],
    [DataType.bundle, { formFieldComponent: BundleFormFieldComponent, tableCellComponent: BundleFormFieldComponent }],
    [DataType.html_block, { formFieldComponent: HtmlBlockFormFieldComponent, tableCellComponent: null }],
    [
      DataType.open_in_player,
      {
        formFieldComponent: OpenInPlayerFormFieldComponent,
        tableCellComponent: OpenInPlayerFormFieldComponent,
      },
    ],
    [DataType.iframe, { formFieldComponent: IframeFormFieldComponent, tableCellComponent: null }],
    [DataType.video, { formFieldComponent: VideoFormFieldComponent, tableCellComponent: null }],
    [DataType.map, { formFieldComponent: MapFormFieldComponent, tableCellComponent: null }],
    [DataType.metric, { formFieldComponent: MetricFormFieldComponent, tableCellComponent: MetricFormFieldComponent }],
    [DataType.rule, { formFieldComponent: RuleFormFieldComponent, tableCellComponent: RuleFormFieldComponent }],
    [DataType.tree, { formFieldComponent: TreeFormFieldComponent, tableCellComponent: null }],
    [DataType.odds, { formFieldComponent: OddsFormFieldComponent, tableCellComponent: OddsFormFieldComponent }],
    [
      DataType.new_money,
      {
        formFieldComponent: NewMoneyFormFieldComponent,
        tableCellComponent: NewMoneyFormFieldComponent,
      },
    ],

    [DataType.codepen, { formFieldComponent: CodePenFormFieldComponent, tableCellComponent: null }],
    [DataType.site_tree, { formFieldComponent: SiteTreeFormFieldComponent, tableCellComponent: null }],
    [DataType.dynamic_link, { formFieldComponent: DynamicLinkFormFieldComponent, tableCellComponent: null }],
    [DataType.moneyline, { formFieldComponent: Backoffice.MoneylineFormFieldComponent, tableCellComponent: null }],
    [DataType.markets, { formFieldComponent: Backoffice.MarketFormFieldComponent, tableCellComponent: null }],
    [DataType.betslip, { formFieldComponent: Backoffice.BetslipFormFieldComponent, tableCellComponent: null }],
    [
      DataType.player_info,
      { formFieldComponent: PlayerInfoFormFieldComponent, tableCellComponent: PlayerInfoFormFieldComponent },
    ],
    [DataType.smart_filter, { formFieldComponent: SmartFilterFormField, tableCellComponent: SmartFilterFormField }],
    [
      DataType.duration,
      { formFieldComponent: DurationFormFieldComponent, tableCellComponent: DurationFormFieldComponent },
    ],
    [DataType.star, { formFieldComponent: StarFormFieldComponent, tableCellComponent: StarFormFieldComponent }],
    [
      DataType.availability_summary,
      {
        formFieldComponent: AvailabilitySummaryFormFieldComponent,
        tableCellComponent: AvailabilitySummaryFormFieldComponent,
      },
    ],
    [
      DataType.stopwatch,
      { formFieldComponent: StopwatchFormFieldComponent, tableCellComponent: StopwatchFormFieldComponent },
    ],
    [
      DataType.deposits_in_24h_threshold_override,
      { formFieldComponent: DepositsIn24hThresholdOverrideComponent, tableCellComponent: null },
    ],
    [
      DataType.daily_deposit_limit_override,
      { formFieldComponent: DepositsIn24hThresholdOverrideComponent, tableCellComponent: null },
    ],
    [
      DataType.personal_lifetime_deposits_thresholds,
      { formFieldComponent: PersonalLifetimeThresholdsComponent, tableCellComponent: null },
    ],
    [
      DataType.personal_lifetime_net_loss_thresholds,
      { formFieldComponent: PersonalLifetimeThresholdsComponent, tableCellComponent: null },
    ],
    [
      DataType.personal_monthly_net_loss_thresholds,
      { formFieldComponent: PersonalMonthlyNetLossThresholdComponent, tableCellComponent: null },
    ],
    [DataType.affordability_settings, { formFieldComponent: AffordabilitySettingsComponent, tableCellComponent: null }],
    [
      DataType.lifetime_net_loss_thresholds_settings,
      { formFieldComponent: LifetimeNetLossThresholdsComponent, tableCellComponent: null },
    ],
    [
      DataType.lifetime_deposit_thresholds_settings,
      { formFieldComponent: LifetimeDepositThresholdsComponent, tableCellComponent: null },
    ],
    [DataType.net_losses, { formFieldComponent: NetLossesComponent, tableCellComponent: null }],
    [DataType.promotion_exclude, { formFieldComponent: PromotionExcludeComponent, tableCellComponent: null }],
    [DataType.player_consents, { formFieldComponent: PlayerConsentsComponent, tableCellComponent: null }],
    [DataType.promo_claim_rate, { formFieldComponent: PromoClaimRateComponent, tableCellComponent: null }],
    [
      DataType.player_restrictions,
      { formFieldComponent: PlayerAppliedRestrictionsTabComponent, tableCellComponent: null },
    ],
    [
      DataType.responsible_gaming_config,
      { formFieldComponent: ResponsibleGamingConfigCardComponent, tableCellComponent: null },
    ],
  ]);

  getTableCellComponent(dataType: DataType): Type<any> {
    const tableCellComponent = this.dataTypes.get(dataType);
    return tableCellComponent ? tableCellComponent.tableCellComponent : UnsupportedTableCellComponent;
  }

  getFormFieldComponent(dataType: DataType): Type<any> {
    const formFieldComponent = this.dataTypes.get(dataType);
    return formFieldComponent ? formFieldComponent.formFieldComponent : UnsupportedFormFieldComponent;
  }
}

export interface DataTypeWidgetWrapper {
  formFieldComponent: Type<any>;
  tableCellComponent: Type<any>;
}
